import { ru } from 'date-fns/locale/ru'
import moment from 'moment'
import { forwardRef } from 'react'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { EIcons } from '@/app/types/iconType'
import { Icon } from '@/shared'

import style from './DatesRangeFilter.module.scss'

import './calendar.css'

registerLocale('ru', ru)

interface IProps {
    startDate: string | null
    endDate: string | null
    onSetStartDate: (date: string | null) => void
    onSetEndDate: (date: string | null) => void
}

export const DatesRangeFilter = (props: IProps) => {
    const { onSetStartDate, onSetEndDate, endDate, startDate } = props
    return (
        <ReactDatePicker
            wrapperClassName={style.wrapperClassName}
            selectsRange={true}
            startDate={startDate ? new Date(startDate) : null}
            endDate={endDate ? new Date(endDate) : null}
            locale='ru'
            dateFormat='dd.MM.YYYY'
            onChange={(update: [Date | null, Date | null]) => {
                const [_startDate, _endDate] = update
                const SD = _startDate ? moment(_startDate).format('YYYY-MM-DD') : null
                const ED = _endDate ? moment(_endDate).format('YYYY-MM-DD') : null
                onSetStartDate(SD)
                onSetEndDate(ED)
            }}
            customInput={<CustomDateInput />}
            // isClearable={true}
            // withPortal
        />
    )
}

const CustomDateInput = forwardRef(({ value, onClick }: { value?: string; onClick?: () => void }, ref) => (
    <div className={style.container} onClick={onClick} ref={ref as any} style={{ width: '100%' }}>
        {value || 'Укажите даты'}
        <div className={style.trigger}>
            <Icon iconName={EIcons.AROW} color='#1F3447' />
        </div>
    </div>
))

CustomDateInput.displayName = 'CustomDateInput'
